/** A new Material Transfer Note. Nothing is written -- and no number is spent -- until the first Post. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { MtnPage } from "@/features/mtn/mtn-page";

export const Route = createFileRoute("/_app/processing/mtn/new")({
  beforeLoad: () => {
    if (!useAuth.getState().can("processing.mtn.issue"))
      throw redirect({ to: "/processing/mtn" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <MtnPage
      mtn={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
      audience="processing"
    />
  );
}
